import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss']
})
export class SocialMediaComponent implements OnInit {
  socialMediaLinks = {

    github: "https://github.com/sreekanthmandala1",
    linkedin: "https://www.linkedin.com/in/sreekanthmandala/",
    gmail: "sreekanthmandala1212@gmail.com",
    instagram : "https://instagram.com/_sreekanth_mandala?igshid=MzRlODBiNWFlZA==",
    facebook: "https://www.facebook.com/sreekanth.mandala.5/"
  };
  constructor() { }

  ngOnInit(): void {
  }

}
